import cx from 'classnames';
import { shape, string, arrayOf, number } from 'prop-types';
import React from 'react';

import { formatAmount } from '../../../utils';

import s from './index.module.css';

const GroupedOffersMessage = ({ offers, detailInfo }) => {
  const isOneOffer = offers.length === 1;

  return (
    <div className={s.wrapper}>
      <div className={s.detailInfo}>{detailInfo}</div>
      <div className={cx(s.offersWrapper, { [s.singleOfferWrapper]: isOneOffer })}>
        {
          offers.map((offer, index) => {
            const delivery = offer.deliveryDays > 0 ? `${offer.deliveryDays} д.` : 'сегодня';

            return (
              <React.Fragment key={offer.key}>
                {!isOneOffer && <span className={s.offerPosition}>{index + 1}.</span>}
                <span className={s.offerDelivery}>{delivery} </span>
                <span className={s.offerPrice}>{formatAmount(offer.price, true)} ₽</span>
              </React.Fragment>
            );
          })
        }
      </div>

    </div>
  );
};

GroupedOffersMessage.propTypes = {
  offers: arrayOf(shape({
    offerKey: string,
    sellerAddress: string,
    deliveryDays: number,
    price: number,
    quantity: number
  })),
  detailInfo: string,
};

GroupedOffersMessage.defaultProps = {
  offers: [],
  detailInfo: '',
};

export default GroupedOffersMessage;
